import { showIframeViewAtom } from '../states/planner';
import { useAtom } from 'jotai';
import useSite from '../hooks/useSite';

const isMobile = () => {
  return window.matchMedia('(max-width: 640px)').matches;
};

const isInIframe = () => {
  return window.self !== window.top;
};

export const IframeViewer = ({ showAllTime }: { showAllTime?: boolean }) => {
  const [showIframeView, setShowIframeView] = useAtom(showIframeViewAtom);
  const [site] = useSite();

  return showIframeView || showAllTime ? (
    isMobile() && isInIframe() ? (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-0 md:p-4">
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            src={site.galleryButton.data}
            className="absolute left-0 top-0 h-full w-full rounded-lg border-0"
            allowFullScreen
            title="Rundvandring"
          />
          <button
            onClick={() => setShowIframeView(false)}
            className="text-s absolute left-1/2 top-4 -translate-x-1/2 rounded bg-black bg-opacity-50 px-4 py-2 text-white hover:bg-opacity-75"
          >
            ✕
          </button>
        </div>
      </div>
    ) : (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-0 md:p-4">
        <div className="relative h-full w-full md:h-[80vh] md:max-w-7xl md:overflow-hidden md:rounded-lg md:bg-black">
          <iframe src={site.galleryButton.data} className="h-full w-full" allowFullScreen title="Virtual Tour"></iframe>
          <button
            onClick={() => setShowIframeView(false)}
            className="absolute left-1/2 top-4 -translate-x-1/2 rounded bg-black bg-opacity-50 px-4 py-2 text-2xl text-white hover:bg-opacity-75"
          >
            ✕
          </button>
        </div>
      </div>
    )
  ) : null;
};
